import {HandoverStepType} from './HandoverStepTypes';

export type ValidationKey =
  | 'header'
  | 'goals'
  | 'tasks'
  | 'recs'
  | 'notes'
  | 'risk'
  | 'noChanges'
  | 'vulnerabilities';

export const validationHeaderMap: Record<ValidationKey, string> = {
  header: 'Account/Contact Issues',
  goals: 'Goals',
  tasks: 'Tasks',
  recs: 'Requirements',
  notes: 'Notes',
  risk: 'Risk Profile',
  noChanges: 'No Changes',
  vulnerabilities: 'Vulnerabilities',
};

export const getGroupHeader = (key: string): string => {
  if (key in validationHeaderMap) {
    return validationHeaderMap[key as ValidationKey];
  }
  return key.charAt(0).toUpperCase() + key.slice(1);
};

export const stepToValidationKey: Record<HandoverStepType, ValidationKey | null> = {
  meeting: 'header',
  resilience: 'vulnerabilities',
  notes: 'notes',
  risk: 'risk',
  risknotes: 'risk',
  goals: 'goals',
  requirements: 'recs',
  'requirements-builder': 'recs',
  tasks: 'tasks',
  summary: null,
  report: null,
};
